'use client';

import { __makeTemplateObject } from '../../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { colors } from '../../../Colors/index.js';

var DropdownFooterWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    display: flex;\n    justify-content: flex-end;\n    padding: 20px 16px;\n    background-color: #fff;\n    height: 80px;\n    border-radius: 0 0 12px 12px;\n    button {\n        &:first-child {\n            margin-right: ", "px;\n        }\n    }\n    ", "\n"], ["\n    border-top: 1px solid ", ";\n    display: flex;\n    justify-content: flex-end;\n    padding: 20px 16px;\n    background-color: #fff;\n    height: 80px;\n    border-radius: 0 0 12px 12px;\n    button {\n        &:first-child {\n            margin-right: ", "px;\n        }\n    }\n    ", "\n"])), colors.grey[90], function (_a) {
    var isSingleSelect = _a.isSingleSelect;
    return (isSingleSelect ? 0 : 10);
}, function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            position: ", ";\n            bottom: 0;\n            width: 100vw;\n            z-index: 10;\n            > button {\n                width: ", ";\n            }\n        "], ["\n            position: ", ";\n            bottom: 0;\n            width: 100vw;\n            z-index: 10;\n            > button {\n                width: ", ";\n            }\n        "])), function (_a) {
        var isShow = _a.isShow;
        return (isShow ? 'fixed' : 'absolute');
    }, function (_a) {
        var isSingleSelect = _a.isSingleSelect;
        return (isSingleSelect ? '100%' : '50%');
    });
});
var templateObject_1, templateObject_2;

export { DropdownFooterWrapper };
//# sourceMappingURL=DropdownFooter.css.js.map
